import { Branding, uploadBrandAsset } from './branding.service';

/**
 * Signed out (setting up a draft), an image can't be uploaded yet: uploads belong to an account. It's kept in the draft
 * as a data: URL instead, shrunk so it fits in browser storage, and uploaded when the hackathon is created.
 */

export const isLocalImage = (url?: string) => !!url && url.startsWith('data:');

/** The image scaled down to fit within maxSize×maxSize (never up), as a data: URL. */
export const imageToDataUrl = async (file: File, maxSize: number): Promise<string> => {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, maxSize / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext('2d')!.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close();
    // WebP keeps transparency and stays small; browsers that can't write it give PNG
    return canvas.toDataURL('image/webp', 0.85);
};

const BRANDING_IMAGES = ['logoUrl', 'bannerUrl'] as const;

/** The branding with any images kept in the draft uploaded, so it's ready to save on the server. */
export const uploadLocalImages = async (branding: Branding): Promise<Branding> => {
    const result = { ...branding };
    for (const key of BRANDING_IMAGES) {
        const url = result[key];
        if (isLocalImage(url)) {
            const blob = await (await fetch(url!)).blob();
            result[key] = await uploadBrandAsset(new File([blob], key, { type: blob.type }));
        }
    }
    return result;
};
